import { Component, OnInit } from '@angular/core';
import { interval, BehaviorSubject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { OfficeStatus } from '../../../../../../shared/office-status';
import { FruHttpService } from '../../../../../../services/fru-http.service';
import { AnalyticsService } from '../../../../../../services/analytics.service';
import { CustomerReviewComponent } from '../../customer-review/customer-review.component';
import { BrandService } from '../../../../../../services/brand.service';
import { BestService } from '../../../../../../services/best.service';

@Component({
  selector: 'app-best-landing-body',
  templateUrl: './best-landing-body.component.html',
  styleUrls: ['./best-landing-body.component.scss'],
})
export class BestLandingBodyComponent implements OnInit {
  public officeStatus: OfficeStatus;
  public customerReviewComponent: CustomerReviewComponent;
  redirectTries: number = 0;
  redirecting: boolean = false;
  loadAPI: Promise<any>;
  CustomReviews: boolean;
  clientId: string;
  beState: string;
  loanType: string;
  isPurchaseEnabled: boolean = true;
  // isABLoanTypeButtons$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public newDesignLoanTypeABTest = true;

  btnOrder = {
    refinance: '1',
    purchase: '2',
    homeequity: '3',
    cashout: '4',
    homeimprovement: '5',
    separator: '6',
    second_mortgage: '8',
    heloc_card: '9',
    heloc: '10',
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fruHttp: FruHttpService,
    private analyticsService: AnalyticsService,
    public brandService: BrandService,
    public best: BestService,
  ) {
    this.analyticsService.getExperiments().subscribe(
      (variationData: any) => {
        // this.newDesignLoanTypeABTest = variationData.enabledVariations.hasOwnProperty('NewDesignLoanTypeV5');
        // this.isFooterAB = variationData.enabledVariations.hasOwnProperty('footerCl');
      }
    );
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.clientId = params.l || null;
      this.beState = params.state || null;
      this.loanType = params.loan_type || null;
    });

    if (this.loanType == 'home-equity' || this.loanType == 'heloc') {
      this.btnOrder = {
        refinance: '2',
        purchase: '6',
        homeequity: '1',
        cashout: '7',
        homeimprovement: '8',
        separator: '9',
        second_mortgage: '3',
        heloc_card: '4',
        heloc: '5',
      };
    } else if (this.loanType == 'cash-out') {
      this.btnOrder = {
        refinance: '4',
        purchase: '3',
        homeequity: '2',
        cashout: '1',
        homeimprovement: '5',
        separator: '6',
        second_mortgage: '8',
        heloc_card: '9',
        heloc: '10',
      };
    } else if (this.loanType == 'purchase') {
      this.btnOrder = {
        refinance: '2',
        purchase: '1',
        homeequity: '3',
        cashout: '4',
        homeimprovement: '5',
        separator: '6',
        second_mortgage: '8',
        heloc_card: '9',
        heloc: '10'
      };
    } else if (this.loanType == 'home-improvement') {
      this.btnOrder = {
        refinance: '2',
        purchase: '3',
        homeequity: '4',
        cashout: '5',
        homeimprovement: '1',
        separator: '6',
        second_mortgage: '8',
        heloc_card: '9',
        heloc: '10'
      };
    }

    if (this.clientId == '22783') {
      // deepcode ignore Ssrf: this method is run from the browser, not the server
      this.fruHttp.getBEstatus(this.clientId, this.beState, 'purchase').subscribe(response => {
        if (response.status == 'success') {
          this.isPurchaseEnabled = response.enabled;
          if (!response.enabled) {
            this.btnOrder.purchase = '7';
          }
        }
      });
    }
  }

  redirectForm(type: string, formType?: string, button?: string) {
    if (this.redirecting) {
      return;
    }


    if (window['siteId'] == 4) {
      window['_paq'].push(['trackGoal', 16]);
    }

    button = button ?? formType ?? type;

    this.redirecting = true;
    this.analyticsService.trackQuestionAnswered();
    this.navigateForm(type, formType, button);
  }

  navigateForm(type: string, formType: string, button: string) {
    this.redirecting = false;

    if (!formType) {
      this.router.navigate(['/rates-form'], { queryParams: { 'LoanPurpose': type, lp_button: button }, queryParamsHandling: 'merge' });
    } else {
      this.router.navigate(['/rates-form'], { queryParams: { 'LoanPurpose': type, 'FormType': formType, lp_button: button }, queryParamsHandling: 'merge' });
    }
  }

  adDisclosurePopup() {
    this.fruHttp.adDisclosurePopup();
  }
}
